import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-roi-section',
  standalone: true,
  templateUrl: './roi-section.component.html',
  styleUrl: './roi-section.component.scss'
})
export class RoiSectionComponent {
  @Output() openROIPopupEvent = new EventEmitter<void>();
}

